module.exports = __webpack_public_path__ + "img/messaging.eb596b45.svg";